module.exports = __webpack_public_path__ + "img/YesOrNo.5df58692.svg";